export const CHANGE_STEP = 'CHANGE_STEP'
export const CHANGE_INFO_VALUE = 'CHANGE_INFO_VALUE'
export const IS_DESABLE_BUTTON = 'IS_DESABLE_BUTTON'
export const CHANGE_UPLOAD_FILE = 'CHANGE_UPLOAD_FILE'
export const DESABLED_UPLOAD_FILE = 'DESABLED_UPLOAD_FILE'
export const UPLOAD_FETCH_DATA = 'UPLOAD_FETCH_DATA'
export const DID_UPLOAD_WORK = 'DID_UPLOAD_WORK'
export const SET_CERT = 'SET_CERT'